import { render, staticRenderFns } from "./visualizarSolicitudesCompra.vue?vue&type=template&id=2d19fd5e&scoped=true&"
import script from "./visualizarSolicitudesCompra.vue?vue&type=script&lang=js&"
export * from "./visualizarSolicitudesCompra.vue?vue&type=script&lang=js&"
import style0 from "./visualizarSolicitudesCompra.vue?vue&type=style&index=0&id=2d19fd5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19fd5e",
  null
  
)

export default component.exports